module.exports = __webpack_public_path__ + "static/media/galeria-fotos-2.6fabfb4c.png";